<h2 mat-dialog-title>Pause Notifications</h2>

<div mat-dialog-content>
  <p>
    Set a date/time to pause notification sending until that moment, or clear the pause to resume notifications.
  </p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Pause date</mat-label>
    <input matInput [matDatepicker]="pauseDatePicker" [(ngModel)]="pauseDate">
    <mat-datepicker-toggle matSuffix [for]="pauseDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #pauseDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Pause time</mat-label>
    <input matInput type="time" [(ngModel)]="pauseTime">
  </mat-form-field>

  <div class="current-value" *ngIf="currentValue">
    Current setting: <code>{{ currentValueLabel }}</code>
  </div>

  <div class="loading" *ngIf="loading">Loading current value...</div>
</div>

<mat-dialog-actions align="end" class="actions gap-10">
  <button mat-raised-button (click)="close()" [disabled]="saving">Cancel</button>
  <button mat-raised-button (click)="clearPause()" [disabled]="saving">Clear Pause</button>
  <button mat-raised-button color="primary" (click)="savePause()" [disabled]="saving || !pauseDate || !pauseTime">Save</button>
</mat-dialog-actions>

